import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { EntityType } from 'common/enums';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiInitiator } from 'common/enums/data.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';
import { EntityDetailsPayload } from 'common/models/data/entityStore.model';

const entityConfig = {
    getEntityDetailsUrl: (payload: EntityDetailsPayload): ApiConfig => {
        if (
            (payload.initiator === ApiInitiator.MasterData ||
                payload.initiator === ApiInitiator.ArchiveList) &&
            payload.entityType === EntityType.Category
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.GET_CATEGORY_INFO}/${payload.id}`,
                ApiMethods.GET
            );
        } else if (
            (payload.initiator === ApiInitiator.MasterData ||
                payload.initiator === ApiInitiator.ArchiveList) &&
            payload.entityType === EntityType.SubCategory
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.SUBCATEGORY_INFO}/${payload.id}`,
                ApiMethods.GET
            );
        } else if (
            (payload.initiator === ApiInitiator.MasterData ||
                payload.initiator === ApiInitiator.ArchiveList) &&
            payload.entityType === EntityType.Indicator
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.INDICATOR_INFO}/${payload.id}`,
                ApiMethods.GET,
                `parentSubCategoryId=${payload.parentSubCategoryId}`
            );
        }
        return new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY_DETAILS}/${payload.id}`,
            ApiMethods.GET,
            `entityType=${payload.entityType}`
        );
    },

    getCategoryDetailsUrl: (payload: EntityDetailsPayload): ApiConfig => {
        if (
            payload.initiator === ApiInitiator.MasterData &&
            payload.entityType === EntityType.Category
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.GET_CATEGORY}/${payload.id}`,
                ApiMethods.GET
            );
        } else if (
            payload.initiator === ApiInitiator.MasterData &&
            payload.entityType === EntityType.SubCategory
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.GET_SUBCATEGORY}/${payload.id}`,
                ApiMethods.GET
            );
        }
        return new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.CATEGORY}/${payload.id}`,
            ApiMethods.GET
        );
    },

    getIndicatorDetailsByIdUrl: (payload: EntityDetailsPayload): ApiConfig => {
        if (
            payload.initiator === ApiInitiator.MasterData &&
            payload.entityType === EntityType.Indicator
        ) {
            return new ApiConfig(
                `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.INDICATOR}/${payload.id}`,
                ApiMethods.GET
            );
        }
        return new ApiConfig(
            `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.INDICATOR}/${payload.id}`,
            ApiMethods.GET
        );
    },

    getSourcesUrl: (payload: ApiInitiator): ApiConfig => {
        // if (payload === ApiInitiator.MasterData) {
        return new ApiConfig(
            `${CONTROLLER.MASTER_DATA}/${METHOD.MASTER_DATA.GET_SOURCES}`,
            ApiMethods.GET
        );
        //}
        // return new ApiConfig(
        //     `${CONTROLLER.DATA_PREVIEW}/${METHOD.DATA_PREVIEW.GET_SOURCES}`,
        //     ApiMethods.GET
        // );
    }
};

export default entityConfig;
